export default "__VITE_ASSET__DNjiYflv__"